import Replayer from './Replayer';

// export { default as Slider } from './Slider/Slider';
export { default as GgbReplayer } from './GgbReplayer';
export { default as DesmosReplayer } from './DesmosReplayer';
export { default as DesActivityReplayer } from './DesActivityReplayer';
export { default as ChatReplayer } from './ChatReplayer';
export { default as ReplayerControls } from './ReplayerControls';
export { default as DesActivityMiniReplayer } from './DesActivityMiniReplayer';
export { default as DesmosMiniReplayer } from './DesmosMiniReplayer';
export { default as SharedMiniReplayer } from './SharedMiniReplayer';
export { default as PyretActivityReplayer } from './PyretActivityReplayer';
// export { default as SharedReplayer } from './SharedReplayer';

export default Replayer;



// WEBPACK FOOTER //
// ./src/Containers/Replayer/index.js